import { type FC, type ReactNode } from "react";
import { SnackbarProvider as SnackbarActualProvider } from "notistack";

const SnackbarProvider: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <SnackbarActualProvider preventDuplicate>{children}</SnackbarActualProvider>
  );
};

export default SnackbarProvider;
